const airCharterList = [
    {
        id: 1,
        content: 'More than 50 business jets are available, covering top international models for a wide range of travel needs',
    },
    {
        id: 2,
        content: 'Covering international mainstream routes and more niche locations',
    },
    {
        id: 3,
        content: 'Cabin services can be customized',
    }
]

export default {
    airCharterList
};